/** Espelha NotaFiscalSaidaExcluirLoteRequest do OrquestradorVendas (POST NotaFiscalSaida/excluir/lote). */
export class NotaFiscalSaidaExcluirLoteRequest {
  idsNFeSaida: number[];
}
